import { gql } from '@apollo/client';

export interface ILibrarySocialMediaLinks {
  id: string;
  twitterUrl: string;
  facebookUrl: string;
  snapchatUrl: string;
  instagramUrl: string;
  whatsAppUrl: string;
  tikTokUrl: string;
  youTubeUrl: string;
  telegramUrl: string;
  webUrl: string;
  linkedInUrl: string;
  pinterestUrl: string;
  tripadvisorUrl: string;
  vkontakteUrl: string;
}

export const LibrarySocialMediaLinksFragment = gql`
  fragment LibrarySocialMediaLinks on LibrarySocialMediaLinks {
    sys {
      id
    }
    twitterUrl
    facebookUrl
    snapchatUrl
    instagramUrl
    whatsAppUrl
    tikTokUrl
    youTubeUrl
    telegramUrl
    webUrl
    linkedInUrl
    pinterestUrl
    tripadvisorUrl
    vkontakteUrl
  }
`;
